export default "__VITE_ASSET__gwZal07Z__"